import { render, staticRenderFns } from "./OthersModal.vue?vue&type=template&id=0b95750e&scoped=true&"
import script from "./OthersModal.vue?vue&type=script&lang=js&"
export * from "./OthersModal.vue?vue&type=script&lang=js&"
import style0 from "./OthersModal.vue?vue&type=style&index=0&id=0b95750e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b95750e",
  null
  
)

export default component.exports